import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import _ from 'lodash'

export interface DialogData {
  any: any
}

@Component({
  selector: 'app-update-other-trans-dialog',
  templateUrl: './update-other-trans-dialog.component.html',
  styleUrls: ['./update-other-trans-dialog.component.less']
})

export class UpdateOtherTransDialogComponent implements OnInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  list = []

  loading = false

  constructor(
    private router: Router,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private dialogRef: MatDialogRef<UpdateOtherTransDialogComponent>,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.list = this.data['list']
  }

  goTo(comp, param) {
    this.ngZone.run(()=>{
    this.router.navigate([comp, param])
    });
  }

  cancel(row) {
    row['cancel'] = true
    this.isFinish()
  }

  update(row) {
    let noTransportCost = false
    // 金額が高すぎないか確認
    const price = Number(row.price)
    if (Number.isNaN(row.price)) {
      alert('交通費が不正な値です。入力しなおしてください')
      row.price = '0'
      return
    }
    if (price) {
      if (price >= 4000) {
        alert('交通費4,000円以上は登録できません。')
        return
      } else if (price >= 2000) {
        if (!window.confirm('交通費が2,000円以上ですが、よろしいでしょうか？')) {
          return
        }
      }
    } else {
      if (!window.confirm('交通費は無しでよろしいでしょうか？')) {
        return
      }
      row.price = '0'
      noTransportCost = true
    }

    this.loading = true

    const data = {
      id: row.id,
      day: row.day,
      workInstead: row.name,
      sequenceNumber: row.sequenceNumber,
      routeMap: row.newMap.start,
      status: row.status,
      
      startName: row.startNameNew,
      startPoint: row.startPointNew,
      
      endName: row.endNameNew,
      endPoint: row.endPointNew,

      transportationExpenses: row.price,
      noTransportCost
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    this.http.post(
      API_BASE_URL + "/api/v1/operations/updateOther?nameSite=" + row.nameSite,
        data, httpOptions
    ).subscribe(() => {
      row.update = true
      this.isFinish()
      this.loading = false
    }, () => {
      alert('エラーが発生しました。');
      this.loading = false
    });
  }

  /**
   * 全てのデータが処理完了であればダイアログを閉じる
   */
  isFinish() {
    // 全て操作が終われば、ダイアログ閉じる
    const exists = this.list.some(item => !item['cancel'] && !item['update']);
    if (!exists) {
      this.dialogRef.close();
    }
  }
}
